module.exports = __webpack_public_path__ + "img/se.4dcdb9dc.svg";